var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('va-inner-loading',{attrs:{"loading":_vm.loading}},[_c('callbacks-table',{staticClass:"mb-4",attrs:{"callbacks":_vm.callbacks,"loading":_vm.loading},on:{"refresh":_vm.fetchCallbacks}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }